import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { XCircle, ArrowLeft, HelpCircle } from "lucide-react";

const REASON_MESSAGES = {
  cancelled: "You closed the payment window before completing the transaction. No amount was charged.",
  "payment-failed": "Your bank declined the payment. Please try a different card or UPI ID.",
  "verification-failed": "The payment couldn't be verified on our servers. If money was debited, it will refund automatically within 5–7 business days.",
};

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const reason = params.get("reason") || "cancelled";
  const message = REASON_MESSAGES[reason] || decodeURIComponent(reason);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center p-6">
      <div className="max-w-md w-full border border-slate-800 rounded-2xl p-10 text-center bg-gradient-to-b from-slate-900/60 to-transparent">
        <XCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
        <p className="font-mono text-[10px] uppercase tracking-widest text-red-300">payment not completed</p>
        <h2 className="font-serif text-3xl text-sky-100 mt-2">No worries — nothing was charged</h2>
        <p className="text-sm text-slate-400 mt-4" data-testid="payment-cancel-reason">
          {message}
        </p>
        {orderId && (
          <p className="text-[11px] font-mono text-slate-600 mt-3">Order reference: {orderId}</p>
        )}

        <div className="mt-8 space-y-2">
          <Link
            to="/pricing"
            data-testid="btn-payment-cancel-retry"
            className="inline-flex items-center justify-center gap-2 w-full px-5 py-3 bg-sky-400 hover:bg-sky-300 text-slate-950 rounded font-medium"
          >
            <ArrowLeft className="w-4 h-4" /> Back to Pricing
          </Link>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 w-full px-5 py-3 border border-slate-700 text-slate-300 hover:text-sky-300 hover:border-sky-500/40 rounded"
          >
            Continue browsing
          </Link>
        </div>

        <p className="text-xs text-slate-600 mt-6 flex items-center justify-center gap-1">
          <HelpCircle className="w-3 h-3" /> Payment issues? Email support@allbusinessonline.in
        </p>
      </div>
    </div>
  );
}
